import { render, staticRenderFns } from "./DebtManagementDetails.vue?vue&type=template&id=6ccb617c"
import script from "./DebtManagementDetails.vue?vue&type=script&lang=js"
export * from "./DebtManagementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports